import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ACCOUNTS_API } from './accounts-api.token';
import { HttpAccountsApiService } from './http/http-accounts-api.service';

/** Registers the live Accounts HTTP implementation. */
export function provideAccounts(): EnvironmentProviders {
  return makeEnvironmentProviders([
    HttpAccountsApiService,
    {
      provide: ACCOUNTS_API,
      useExisting: HttpAccountsApiService,
    },
  ]);
}
